"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var TextArea = react_1["default"].forwardRef(function (_a, ref) {
    var value = _a.value, className = _a.className, placeholder = _a.placeholder, onChange = _a.onChange, focusOnMount = _a.focusOnMount, _b = _a.focusTarget, focusTarget = _b === void 0 ? false : _b, _c = _a.additionalAttributes, additionalAttributes = _c === void 0 ? {} : _c;
    var onChangeValue = function (e) {
        if (onChange) {
            onChange(e.target.value);
        }
    };
    // Resize the textarea whenever the value is changed
    var textAreaElement = react_1["default"].useRef(null);
    react_1["default"].useImperativeHandle(ref, function () { return textAreaElement.current; });
    react_1["default"].useEffect(function () {
        if (textAreaElement.current) {
            textAreaElement.current.style.height = '';
            textAreaElement.current.style.height =
                textAreaElement.current.scrollHeight + 'px';
        }
    }, [value, textAreaElement]);
    // Focus the textarea when it is mounted
    react_1["default"].useEffect(function () {
        if (focusOnMount && textAreaElement.current) {
            textAreaElement.current.focus();
        }
    }, [textAreaElement]);
    return (react_1["default"].createElement("textarea", __assign({ "data-focus-target": focusTarget, rows: 1, style: { resize: 'none', overflowY: 'hidden' }, className: className, placeholder: placeholder, ref: textAreaElement, onChange: onChangeValue, value: value }, additionalAttributes)));
});
exports["default"] = TextArea;
